<template>
  <div class="review-contact-address">
    <AmTypography
      text="Selecione o tipo de entrega"
      typography-style="l5"
      weight="bold"
    />
    <br />
    <AmList
      v-if="getFreights.length > 0"
      :key="updateDomKey"
    >
      <template v-for="(freight, idx) in getFreights">
        <label
          :key="idx"
          class="list__item mb-0"
          :for="`am-radio-select-review-${idx}`"
        >
          <AmListItem custom-class="white">
            <template #append>
              <AmRadio
                :id="`select-review-${idx}`"
                v-model="freightSelected"
                :class="theme.color"
                :option="{ value: freight.id }"
                :name="freight.name"
                @change="changeFreight(freight)"
              />
            </template>
            <template #title>
              <div v-if="cartFreight(freight)">
                {{ freight.name }}
              </div>
              <div v-else>
                <AmTypography
                  :text="freight.name"
                  text-color="success"
                  typography-style="l5"
                />
              </div>
            </template>
            <template #prepend>
              {{ getFreightPrice(freight) | currencyBRL }}
            </template>
          </AmListItem>
        </label>
        <hr
          :key="`${freight.name}-hr`"
          class="review-contact-address__divider"
        />
      </template>
    </AmList>

    <ContactAddress
      v-if="!loadingGlobal"
      show-edit
      @editContact="editContact()"
      @editAdress="editAdress()"
    />
  </div>
</template>

<script>
import themeMixin from '@/components/mixins/themeMixin'
import currencyFilterMixin from '@/components/mixins/currencyFilterMixin'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import AmList from '@/components/molecules/AmList.vue'
import AmListItem from '@/components/atoms/AmListItem.vue'
import queryPersistance from '@/components/mixins/queryPersistance'

import ContactAddress from '@/views/Checkout/partials/ContactAddress/ContactAddress.vue'

export default {
  name: 'ReviewContactAddress',
  components: {
    AmList,
    AmListItem,
    ContactAddress,
  },
  mixins: [themeMixin, currencyFilterMixin, queryPersistance],
  data() {
    return {
      freightSelected: '',
      updateDomKey: 0,
      freightTypeSelected: null,
    }
  },
  computed: {
    ...mapState('Checkout', {
      loadingGlobal: (state) => state.cartLoading,
      freight_selected: (state) => {
        return state.cart.freight_id
      },

      cart: (state) => state.cart,
    }),
    ...mapGetters('Cart', ['getFreights', 'getOrderBumps', 'getOrderBumpRedirected']),
  },
  watch: {
    cart: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue?.freights.length) {
          this.freightSelected = this.freight_selected
          this.freightTypeSelected = this.freight_selected
        }
      },
    },
    freightSelected: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue === '') {
          this.SET_DISABLED_STATE_PAYMENT(true)
        } else {
          this.SET_DISABLED_STATE_PAYMENT(false)
        }
      },
    },
  },
  created() {
    const firstFreightHasInCar = this.cart.freight_id === this.getFreights[0].id
    this.SET_DISABLED_STATE_PAYMENT(!firstFreightHasInCar)

    if (this.getFreights.length && !firstFreightHasInCar) {
      this.changeFreight(this.getFreights[0])
    }
  },
  methods: {
    ...mapActions('Checkout', ['addFreight', 'fetchCart']),
    ...mapMutations('Checkout', ['SET_CURRENT_STEP', 'SET_DISABLED_STATE_PAYMENT']),
    ...mapMutations('Cart', ['SET_ORDER_REDIRECT']),
    changeFreight(freight) {
      this.SET_DISABLED_STATE_PAYMENT(false)
      this.freightTypeSelected = freight.id
      this.updateDomKey += 1
      this.postFreightSelected()
    },
    async postFreightSelected() {
      try {
        const { hash: cartHash, freight_id: freightId } = this.cart
        if (!freightId) {
          await this.addFreight(this.freightTypeSelected)
          await this.fetchCart(cartHash)
          return
        }
        await this.addFreight(this.freightTypeSelected)
        await this.fetchCart(cartHash)
      } catch (error) {
        throw new Error(error)
      }
    },
    editAdress() {
      this.$router.push({
        name: 'new.stepAddress',
        params: { newRoute: 'new.stepReviewAddress' },
        query: { pl: this.getPl?.pl },
      })
    },
    editContact() {
      this.$router.push({
        name: 'new.dataStep',
        params: { newRoute: 'new.stepReviewAddress' },
        query: { pl: this.getPl?.pl },
      })
    },
    getFreightPrice(freight) {
      return this.cartFreight(freight) ? freight.value : ''
    },
    cartFreight(freight) {
      return freight.value > 0
    },
    previousStep() {
      this.$router.push({ name: 'new.stepAddress', query: { pl: this.getPl?.pl } })
    },
    nextStep() {
      return new Promise((resolve) => {
        const orderBumps = this.getOrderBumps
        const orderBumpsRedirected = this.getOrderBumpRedirected

        if (orderBumps && !orderBumpsRedirected) {
          this.$router.push({ name: 'new.stepPaymentCardOffer', query: { pl: this.getPl?.pl } })
        } else {
          this.$router.push({ name: 'new.stepPayment', query: { pl: this.getPl?.pl } })
        }
        resolve()
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.review-contact-address {
  width: 100%;

  .list__item {
    width: inherit;
  }

  &__divider {
    margin: 0;
  }

  &__divider:last-child {
    display: none;
  }
}
</style>
